import React from "react";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import {
  getAdminReturnSession,
  clearAdminReturnSession,
  setAuthSessionCookies,
} from "@/lib/authCookies";

const AssumeSessionBanner = () => {
  const navigate = useNavigate();
  const session = getAdminReturnSession();

  if (!session?.token) {
    return null;
  }

  const targetLabel = session.targetEmail || session.targetName || "user";

  const handleExit = () => {
    setAuthSessionCookies({
      token: session.token,
      email: session.adminEmail || Cookies.get("email") || "",
      accountType: "admin",
    });
    clearAdminReturnSession();
    navigate("/admin");
  };

  return (
    <>
      <div
        className="fixed top-0 inset-x-0 z-[100] bg-amber-500/95 text-[#111827] px-4 py-2 flex items-center justify-center gap-4 text-sm font-medium"
        data-testid="assume-session-banner"
      >
        <span>Viewing as {targetLabel}</span>
        <button
          type="button"
          onClick={handleExit}
          className="underline hover:no-underline font-semibold"
        >
          Exit to Admin
        </button>
      </div>
      <div className="h-10" aria-hidden="true" />
    </>
  );
};

export default AssumeSessionBanner;
